export default __webpack_public_path__ + "src/images/function-call.svg";